import Circle from "../LogoSVG/Circle";

function Paragraph({ children, isDot, className }: any) {
  return (
    <>
      {isDot ? (
        <div className="flex items-start ">
          <Circle className="w-[6px] h-[6px] mt-[7px] flex-shrink-0" />
          <p className={`ml-3 mb-5 text-gray-6 text-pretty tracking-[0.025em] ${className}`}>
            {children}
          </p>
        </div>
      ) : (
        <p className={`mb-5  text-gray-6 text-pretty tracking-[0.025em] ${className}`}>
          {children}
        </p>
      )}
    </>
  );
}

export default Paragraph;
